import { createTheme } from '@mui/material/styles';


const theme = createTheme({
  typography: {
    fontFamily: ['"Work Sans"', 'sans-serif'].join(','),
    button: {
      textTransform: 'none'
    },
    input: {
      height: "50px"
    }
  }
}, 
// { name: 'MuiDrawer' }, 
// { name: 'MuiAvatar' },
// { name: 'MuiList' },
// { name: 'MuiTypography' },
// { name: 'MuiGrid' },
// { name: 'MuiCardContent' },
// { name: 'MuiButton' },
// { name: 'MuiFormControlLabel' }
);
export default theme;

